{
  "navTitle": "{{name}} — Presets",
  "title": "Presets",
  "subtitle": "Saved shot recipes with replaceable characters, locations, and props.",
  "emptyTitle": "No presets yet",
  "emptyDescription": "Open a finished shot and save it as a preset. You can then preview it as a future user.",
  "createFromShot": "Save shot as preset",
  "slotsCount": "{{count}} slots",
  "statusReady": "Ready",
  "statusDraft": "Draft",
  "filterPlaceholder": "Search presets",
  "clearFilter": "Clear",
  "selectHint": "Select a preset from the list",
  "referencesTitle": "References",
  "promptTitle": "Prompt",
  "reviewGeneration": "Generation",
  "reviewStoryboardProvider": "Storyboard provider",
  "reviewStoryboardModel": "Storyboard model",
  "reviewVideoProvider": "Video provider",
  "reviewVideoModel": "Video model",
  "reviewDuration": "Duration",
  "reviewDurationValue": "{{sec}}s",
  "reviewFrameFormat": "Frame format",
  "authorMode": "Author",
  "consumerMode": "As user",
  "refreshFromShot": "Update from source shot",
  "delete": "Delete",
  "deleteConfirmTitle": "Delete preset?",
  "deleteConfirmMessage": "The preset and its hidden working shots will be removed. The original shot stays.",
  "internalEntities": "Kept internal",
  "hiddenAssets": "Hidden assets",
  "visibleAssets": "Visible assets",
  "noSlots": "No replaceable slots",
  "required": "Required",
  "optional": "Optional",
  "fillSlot": "Choose",
  "clearSlot": "Clear",
  "generateStoryboard": "Generate storyboard",
  "generateVideo": "Generate video",
  "generating": "Generating…",
  "assemblePreview": "Assemble preview",
  "assembling": "Assembling…",
  "previewEmpty": "Fill required slots and assemble a preview, then generate.",
  "mediaEmpty": "Preview not assembled yet.",
  "loadFailed": "Could not load preset data",
  "saveFailed": "Could not save preset",
  "previewFailed": "Could not assemble preview",
  "deleted": "Preset deleted",
  "publish": "Publish to Creator Studio",
  "unpublish": "Unpublish",
  "published": "Published",
  "publishCategory": "Category",
  "publishNeedVideo": "Publish requires a video on the template shot",
  "publishSuccess": "Published to Creator Studio",
  "unpublishSuccess": "Unpublished",
  "kindCharacter": "Character",
  "kindLocation": "Location",
  "kindProp": "Prop",
  "wizard": {
    "title": "Create preset",
    "editTitle": "Edit preset",
    "stepName": "Name",
    "stepSlots": "Replaceable entities",
    "stepAssets": "Hidden assets",
    "stepReview": "Review",
    "reviewHint": "Review the preset before saving. You can go back to change any step.",
    "reviewUntitled": "Untitled preset",
    "reviewSlots": "Replaceable slots ({{count}})",
    "reviewNoSlots": "No replaceable slots",
    "reviewInternal": "Kept internal ({{count}})",
    "reviewIncludedAssets": "Included assets ({{count}})",
    "reviewNoAssets": "No included assets",
    "reviewSkippedAssets": "Skipped ({{count}})",
    "reviewGeneration": "Generation",
    "reviewProvider": "Storyboard provider",
    "reviewStoryboardModel": "Storyboard model",
    "reviewVideoProvider": "Video provider",
    "reviewVideoModel": "Video model",
    "reviewDuration": "Duration",
    "reviewDurationValue": "{{sec}}s",
    "reviewFrameFormat": "Frame format",
    "nameLabel": "Name",
    "descriptionLabel": "Description",
    "namePlaceholder": "Preset name",
    "descriptionPlaceholder": "What this recipe is for",
    "slotsHint": "Mark what a future user must supply. Everything else stays baked into the preset.",
    "modeSlot": "User fills this",
    "modeInternal": "Keep internal",
    "required": "Required",
    "assetsHint": "Choose which extra materials travel with the preset and whether the future user can see them.",
    "omit": "Skip",
    "hidden": "Include, hide",
    "visible": "Include, show",
    "back": "Back",
    "next": "Next",
    "create": "Create preset",
    "save": "Save",
    "noEntities": "This shot has no characters, location, or props to expose as slots.",
    "noAssets": "No extra references or versions to hide.",
    "refKind": "Reference",
    "versionKind": "Version",
    "active": "Active",
    "videoDemo": "Demo video · always included"
  }
}
